import DzenIcon from 'assets/images/icons/platforms/dzen.svg?react';
import LikeeIcon from 'assets/images/icons/platforms/likee_video.svg?react';
import OkIcon from 'assets/images/icons/platforms/ok.svg?react';
import PinterestIcon from 'assets/images/icons/platforms/pinterest.svg?react';
import RutubeIcon from 'assets/images/icons/platforms/rutube.svg?react';
import SnapChatIcon from 'assets/images/icons/platforms/snapchat.svg?react';
import TelegramIcon from 'assets/images/icons/platforms/telegram.svg?react';
import TiktokIcon from 'assets/images/icons/platforms/tiktok.svg?react';
import TwichIcon from 'assets/images/icons/platforms/twitch.svg?react';
import VcIcon from 'assets/images/icons/platforms/vc.svg?react';
import VkIcon from 'assets/images/icons/platforms/vk.svg?react';
import VkVideoIcon from 'assets/images/icons/platforms/vk_video.svg?react';
import WeChatIcon from 'assets/images/icons/platforms/wechat.svg?react';
import WhatsappIcon from 'assets/images/icons/platforms/whatsapp.svg?react';
import YoutubeIcon from 'assets/images/icons/platforms/youtube.svg?react';
import { EPlatformTypes } from 'entities/Source';

export const PLATFORM_TYPES: Record<EPlatformTypes, { name: string; icon: JSX.Element }> = {
	[EPlatformTypes.DZEN]: { name: 'Dzen', icon: <DzenIcon /> },
	[EPlatformTypes.LIKEE]: { name: 'Likee.video', icon: <LikeeIcon /> },
	[EPlatformTypes.RUTUBE]: { name: 'Rutube', icon: <RutubeIcon /> },
	[EPlatformTypes.TELEGRAM]: { name: 'Telegram', icon: <TelegramIcon /> },
	[EPlatformTypes.YOUTUBE]: { name: 'Youtube', icon: <YoutubeIcon /> },
	[EPlatformTypes.OK]: { name: 'OK', icon: <OkIcon /> },
	[EPlatformTypes.PINTEREST]: { name: 'Pinterest', icon: <PinterestIcon /> },
	[EPlatformTypes.SNAPCHAT]: { name: 'Snapchat', icon: <SnapChatIcon /> },
	[EPlatformTypes.TIKTOK]: { name: 'Tiktok', icon: <TiktokIcon /> },
	[EPlatformTypes.TWICH]: { name: 'Twich', icon: <TwichIcon /> },
	[EPlatformTypes.VK]: { name: 'VK', icon: <VkIcon /> },
	[EPlatformTypes.VK_VIDEO]: { name: 'VK Video', icon: <VkVideoIcon /> },
	[EPlatformTypes.WECHAT]: { name: 'WeChat', icon: <WeChatIcon /> },
	[EPlatformTypes.WHATSAPP]: { name: 'Whatsapp', icon: <WhatsappIcon /> },
	[EPlatformTypes.VC]: { name: 'Vc.ru', icon: <VcIcon /> },
};
